/**
 * UI-only gate for the Dev Tools section and Pay-Policy Templates: one unlock opens both for the session.
 *
 * The password is compiled into the bundle (REACT_APP_DEV_TOOLS_PASSWORD) so this is a
 * speed bump for casual browsing, NOT security. Real access control is the AdminAccounts
 * allow-list enforced by superadmin-server on every request.
 */
export const DEV_TOOLS_UNLOCKED_KEY = 'devToolsUnlocked';

export const devToolsPassword = (): string | undefined => process.env.REACT_APP_DEV_TOOLS_PASSWORD;

const defaultStorage = (): Storage => window.sessionStorage;

export const isConfigured = (password: string | undefined = devToolsPassword()): boolean => typeof password === 'string' && password.length > 0;

export const isUnlocked = (storage: Storage = defaultStorage()): boolean => storage.getItem(DEV_TOOLS_UNLOCKED_KEY) === '1';

export const unlock = (attempt: string, password: string | undefined = devToolsPassword(), storage: Storage = defaultStorage()): boolean => {
  if (!isConfigured(password) || attempt !== password) return false;
  storage.setItem(DEV_TOOLS_UNLOCKED_KEY, '1');
  return true;
};

export const lock = (storage: Storage = defaultStorage()): void => storage.removeItem(DEV_TOOLS_UNLOCKED_KEY);
